import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import CompleteIcon from '@mui/icons-material/DoneAll'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'
import { currencyFieldOptions } from '../../custom/currency-field'

const formatCurrency = v => Intl.NumberFormat('en-US', currencyFieldOptions).format(v)

const materialGradeDisplayNames = {
  commercial: 'COMM',
  state: 'STATE',
}

const getMaterialAndGrade = (materialName, materialGradeKey) => {
  if (!materialName) return null
  return [
    materialName,
    materialGradeDisplayNames[materialGradeKey] == null ? '' : ` (${materialGradeDisplayNames[materialGradeKey]})`,
  ].join('')
}

const getTonnageRate = (rate, isFlat) => {
  return [
    formatCurrency(rate),
    isFlat ? '(flat)' : null,
  ].filter(Boolean).join(' ')
}

const acceptanceStatusTypes = {
  accepted: {
    iconColor: 'success',
    buttonColor: 'success',
    buttonText: 'form.acceptButton',
    statusMessage: 'form.acceptedStatusMessage',
    changeAction: 'form.changeToDeclinedAction',
    Icon: CheckIcon,
  },
  declined: {
    iconColor: 'secondary',
    buttonColor: 'error',
    buttonText: 'form.declineButton',
    statusMessage: 'form.declinedStatusMessage',
    changeAction: 'form.changeToAcceptedAction',
    Icon: CloseIcon,
  },
}

const completionStatusTypes = {
  true: {
    iconColor: 'success',
    statusMessage: 'form.completedStatusMessage',
    changeAction: 'form.undoCompleteAction',
    Icon: CompleteIcon,
  },
  false: {
    buttonColor: 'success',
    buttonText: 'form.completeButton',
    Icon: CompleteIcon,
  },
}

const cancelConfirmStatusTypes = {
  true: {
    color: 'error',
    statusMessage: 'form.cancelConfirmedStatusMessage',
    Icon: ErrorIcon,
  },
  false: {
    color: 'error',
    buttonText: 'form.confirmCancelButton',
    statusMessage: 'form.awaitingCancelConfirmationStatusMessage',
    Icon: ErrorIcon,
  },
}

const suspendedConfirmStatusTypes = {
  true: {
    color: 'warning',
    statusMessage: 'form.suspendConfirmedStatusMessage',
    Icon: WarningIcon,
  },
  false: {
    color: 'warning',
    buttonText: 'form.confirmSuspendButton',
    statusMessage: 'form.suspendedStatusMessage',
    Icon: WarningIcon,
  },
}

export {
  acceptanceStatusTypes,
  completionStatusTypes,
  cancelConfirmStatusTypes,
  suspendedConfirmStatusTypes,
  getMaterialAndGrade,
  getTonnageRate,
  formatCurrency,
}
